import {get, post, del, put} from './http'
import Common from '../js/Common'

// 网站
export const captcha = () => get(Common.captcha)

// 用户登录
export const userLogin = (data) => get(Common.userLogin, data)
// 用户注册
export const userRegister = (data) => post(Common.userRegister, data)

// 创建ID
export const createObjectID = () => get(Common.createObjectID)

// 管理员登录
export const backManageLogin = (data) => get(Common.backManageLogin, data)
// 获取注册码
export const getRegisterCode = (data) => get(Common.registerCode, data)

// 获取电影列表
export const getMovieList = (data) => get(Common.movieList, data)
// 获取电影详情
export const getMovieDetail = (data) => get(Common.movieDetail, data)
// 获取系列电影详情
export const getMovieDepartmentList = (data) => get(Common.movieDepartmentList, data)
// 获取系列电影详情
export const getMovieDepartmentDetail = (data) => get(Common.movieDepartmentDetail, data)

// 获取电视剧列表
export const getTVSeriesList = (data) => get(Common.tvseriesList, data)
// 获取电视剧详情
export const getTVSeriesDetail = (data) => get(Common.tvseriesDetail, data)
// 获取系列电视剧详情
export const getTVSeriesDepartmentList = (data) => get(Common.tvseriesDepartmentList, data)
// 获取系列电视剧详情
export const getTVSeriesDepartmentDetail = (data) => get(Common.tvseriesDepartmentDetail, data)

// 获取动漫列表
export const getComicList = (data) => get(Common.comicList, data)
// 获取动漫详情
export const getComicDetail = (data) => get(Common.comicDetail, data)
// 获取系列动漫详情
export const getComicDepartmentList = (data) => get(Common.comicDepartmentList, data)
// 获取系列动漫详情
export const getComicDepartmentDetail = (data) => get(Common.comicDepartmentDetail, data)

// 获取blog列表
export const getBlogList = (data) => get(Common.blogList, data)
// 获取blog详情
export const getBlogDetail = (data) => get(Common.blogDetail, data)
// 新建blog
export const addBlog = (data) => post(Common.addBlog, data)
// 删除blog
export const delBlog = (data) => del(Common.delBlog, data)
// 修改blog
export const updateBlog = (data) => put(Common.updateBlog, data)

// 获取标签列表
export const getBlogTagList = (data) => get(Common.blogTagList, data)

// 删除blog图片
export const removeBlogImage = (data) => del(Common.removeBlogImage, data)

// 新建问题反馈
export const addFeedback = (data) => post(Common.addFeedback, data)
// 获取问题反馈
export const getFeedBackList = (data) => get(Common.feedbackList, data)
export const getFeedBackDetail = (data) => get(Common.feedbackDetail, data)
export const readFeedback = (data) => put(Common.readFeedback, data)
export const delFeedback = (data) => del(Common.delFeedback, data)

// 问题反馈 发送bark消息
export const sendBarkMessage = (data) => post(Common.url_bark, data)



// WEBPACK FOOTER //
// ./src/request/api.js